export const companyData = {
  name: "Hirwai Landscape",
  tagline: "Crafting Green Dreams, Nurturing Nature",
  description: "Transforming spaces into sustainable sanctuaries with passion, expertise, and innovative design",
  phone: "+91-91759 32372",
  email: "hirwailandscapers@gmail.com",
  website: "https://hirwai.com",
  whatsapp: "https://wa.me/9175932372",
  linkedin: "https://in.linkedin.com/in/trupti-sawant-a24604130",
  location: "https://maps.app.goo.gl/2NbS5Da1qLhr7YbE8",
  address: "1103, Ambika, Sardar Heights, Tithal Road, Valsad, Gujarat 396001, India"
};

export const contactIcons = [
  { icon: "Mail", href: "mailto:hirwailandscapers@gmail.com", label: "Email", color: "text-emerald-600" },
  { icon: "Phone", href: "tel:+919175932372", label: "Phone", color: "text-teal-600" },
  { icon: "MessageCircle", href: "https://wa.me/9175932372", label: "WhatsApp", color: "text-green-600" },
  { icon: "Linkedin", href: "https://in.linkedin.com/in/trupti-sawant-a24604130", label: "LinkedIn", color: "text-blue-600" },
  { icon: "MapPin", href: "https://maps.app.goo.gl/2NbS5Da1qLhr7YbE8", label: "Map", color: "text-red-500" },
  { icon: "Globe", href: "https://hirwai.com", label: "Website", color: "text-purple-600" },
];

export const services = [
  {
    title: "Landscape Design",
    icon: "Palette",
    text: "Tailored green solutions for homes and offices.",
    description: "Our expert landscape designers work closely with you to create stunning outdoor spaces that reflect your personal style and complement your property. We consider factors like climate, soil conditions, maintenance requirements, and your lifestyle to design sustainable and beautiful landscapes that thrive year-round.",
    features: ["Custom Design Plans", "3D Visualization", "Plant Selection", "Seasonal Planning"]
  },
  {
    title: "Vertical Gardens",
    icon: "Leaf",
    text: "Space-efficient vertical planting for walls and balconies.",
    description: "Transform any vertical surface into a living masterpiece with our innovative vertical garden solutions. Perfect for urban spaces, these installations maximize greenery in minimal space while improving air quality and creating stunning visual impact. Our systems include automated irrigation and low-maintenance plant selections.",
    features: ["Modular Systems", "Automated Irrigation", "Air Purification", "Space Optimization"]
  },
  {
    title: "Irrigation Systems",
    icon: "Droplets",
    text: "Smart watering systems that conserve water.",
    description: "Our state-of-the-art irrigation systems use smart technology to deliver the right amount of water at the right time, reducing waste and ensuring optimal plant health. Features include weather sensors, soil moisture monitoring, and mobile app control for complete automation and water conservation.",
    features: ["Smart Controllers", "Weather Sensors", "Mobile App Control", "Water Conservation"]
  },
  {
    title: "Garden Maintenance",
    icon: "Wrench",
    text: "Scheduled upkeep to keep your garden healthy.",
    description: "Keep your landscape looking its best year-round with our comprehensive maintenance services. Our certified horticulturists provide regular care including pruning, fertilizing, pest control, and seasonal adjustments to ensure your garden remains healthy, vibrant, and beautiful through every season.",
    features: ["Regular Pruning", "Fertilization", "Pest Control", "Seasonal Care"]
  },
  {
    title: "Hardscaping",
    icon: "Mountain",
    text: "Pathways, patios, and stone structures.",
    description: "Create lasting beauty and functionality with our hardscaping services. From elegant stone pathways and cozy patios to retaining walls and water features, we use premium materials and expert craftsmanship to build structures that enhance your landscape and stand the test of time.",
    features: ["Stone Pathways", "Patio Construction", "Retaining Walls", "Water Features"]
  },
  {
    title: "Outdoor Lighting",
    icon: "Lightbulb",
    text: "Ambient lighting for landscapes.",
    description: "Extend the beauty of your landscape into the evening hours with our professional outdoor lighting solutions. We design and install energy-efficient LED systems that highlight your garden's best features, improve safety, and create magical nighttime ambiance for entertaining and relaxation.",
    features: ["LED Technology", "Accent Lighting", "Safety Illumination", "Smart Controls"]
  },
];

export const technologies = [
  "Smart Irrigation Tech",
  "Native Plant Integration",
  "Modular Vertical Farming",
  "Drone-assisted Garden Mapping",
];

export const contactMethods = [
  { 
    type: "phone", 
    text: "Call Trupti Rohini", 
    value: "+91-91759 32372", 
    href: "tel:+919175932372", 
    icon: "Phone" 
  },
  { 
    type: "email", 
    text: "Mail", 
    value: "hirwailandscapers@gmail.com", 
    href: "mailto:hirwailandscapers@gmail.com", 
    icon: "Mail" 
  },
  { 
    type: "whatsapp", 
    text: "WhatsApp", 
    value: "+91-91759 32372", 
    href: "https://wa.me/9175932372", 
    icon: "MessageCircle" 
  },
  { 
    type: "map", 
    text: "Visit our location", 
    value: "1103, Ambika, Sardar Heights, Tithal Road, Valsad, Gujarat 396001, India", 
    href: "https://maps.app.goo.gl/2NbS5Da1qLhr7YbE8", 
    icon: "MapPin" 
  },
];